<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Идентификатор гос. контракта</div>
            <div class="dx-field-value">
                <ai-text-box-readonly :value="data?.code" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const data = inject('data');
</script>
